// Helper functions for storing and retrieving prohibited query parameters as cookies

import { getCookieByName, setCookie } from './cookie_utils'

const COOKIE_PREFIX = 'bb_'

// Set during init so getter functions know which params to read
let prohibitedParams: string[] = []

const storeProhibitedQueryParamsAsCookies = (params: string[]) => {
  prohibitedParams = params
  const currentQueryParams = new URLSearchParams(window.location.search)

  params.forEach((param) => {
    const value = currentQueryParams.get(param)
    if (!value) return
    setCookie(`${COOKIE_PREFIX}${param}`, value)
  })
}

const clearQueryParameters = (params: string[]) => {
  const queryParams = new URLSearchParams(window.location.search)

  params.forEach((param) => {
    queryParams.delete(param)
  })

  history.replaceState(
    null,
    '',
    `${window.location.pathname}?${queryParams.toString()}`,
  )
}

export const getQueryParametersString = () => {
  // Start with current URL params (e.g. step4=true, utm_source=...)
  const currentParams = new URLSearchParams(window.location.search)
  // Add back prohibited params from cookies (they were stripped from the URL)
  prohibitedParams.forEach((param) => {
    if (!currentParams.has(param)) {
      const value = getCookieByName(`${COOKIE_PREFIX}${param}`)
      if (value) currentParams.set(param, value)
    }
  })
  return currentParams.toString()
}

export const getQueryParametersDict = () => {
  const searchParams = new URLSearchParams(window.location.search)
  return Object.fromEntries(searchParams.entries())
}

export const storeAndClearProhibitedQueryParams = (params: string[]) => {
  storeProhibitedQueryParamsAsCookies(params)
  clearQueryParameters(params)
}

export const getFullUrlWithProhibitedParams = () => {
  const url = new URL(window.location.href)
  prohibitedParams.forEach((param) => {
    const value = getCookieByName(`${COOKIE_PREFIX}${param}`)
    if (value && !url.searchParams.has(param)) {
      url.searchParams.set(param, value)
    }
  })
  return url.toString()
}
